// Formats a computed standings value based on the tournament type.
// - "average": raw value is a 0..1 share -> display as percentage
// - "placement" / "bracket": raw value is already points -> display as plain number
export function formatScore(value, tournamentType, opts = {}) {
  const v = Number(value) || 0;
  const t = (tournamentType || "average").toLowerCase();
  const { digits = 2, suffix = "" } = opts;
  if (t === "average") {
    return `${(v * 100).toFixed(digits)}%`;
  }
  // placement / bracket -> plain points, trim trailing zeros
  const rounded = v.toFixed(digits);
  const trimmed = rounded.replace(/\.?0+$/, "");
  return suffix ? `${trimmed} ${suffix}` : trimmed;
}

export function scoreLabel(tournamentType) {
  const t = (tournamentType || "average").toLowerCase();
  if (t === "placement") return "POINTS";
  if (t === "bracket") return "MATCH PTS";
  return "AVG SCORE";
}
